import styled from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 'calc(100vh - 200rem)',
  flex: 1,
  gap: '16rem',
});

export const MapContainer = styled.div({
  position: 'relative',
  flex: 1,
  width: '100%',
  minHeight: '290rem',
  marginTop: '50rem',
});

// The landing state puts the ZIP search and the hero side by side (see the
// SD-1720 mockup). Outside that state the wrappers collapse to `display:
// contents` so the markup lays out exactly as it did before — StoreSearch keeps
// a stable position in the React tree either way, which matters because
// remounting it would reset its antd Form state and re-fire its effects.
export const LandingSection = styled.div<{ $twoColumn: boolean }>(
  ({ $twoColumn, theme }) =>
    $twoColumn
      ? {
          display: 'flex',
          alignItems: 'flex-start',
          gap: '40rem',

          [theme.breakpoint.media.max.md]: {
            flexDirection: 'column',
            gap: '24rem',
          },
        }
      : { display: 'contents' }
);

export const SearchColumn = styled.div<{ $twoColumn: boolean }>(
  ({ $twoColumn, theme }) =>
    $twoColumn
      ? {
          flex: '1 1 44%',
          minWidth: 0,

          [theme.breakpoint.media.max.md]: {
            flex: '1 1 auto',
            width: '100%',
          },
        }
      : { display: 'contents' }
);

export const HeroColumn = styled.div(({ theme }) => ({
  flex: '1 1 56%',
  minWidth: 0,

  [theme.breakpoint.media.max.md]: {
    flex: '1 1 auto',
    width: '100%',
  },
}));
